export default {"src":"/_next/static/media/wr-active.8fc41d5b.svg","height":125,"width":125,"blurWidth":0,"blurHeight":0};